import * as ko from 'knockout';

import { Event } from 'Core/Common/Event';

import { UserManager } from 'User/UserManager';
import { UserModel } from "User/Store/Models/UserModel";
import { LABELS } from "Core/Components/Translation/Locales";

import HeaderTemplate from 'MenuManager/Header/Templates/Header.html';
import { Brand } from '../../Core/Common/Brand';
ko.templates['MenuManager/Header/Templates/Header'] = HeaderTemplate;

export class Header extends Event {
	private _user: KnockoutObservable<UserModel>;
	private _dbName: KnockoutObservable<string>;
	IsAuthenticated: KnockoutObservable<boolean>;
	LogoImage: KnockoutObservable<string>;
	private _labels = LABELS;

	private static _instance;
	private static _allowInstantiation: boolean;

	constructor() {
		super();
		if (!Header._allowInstantiation) {
			throw new Error("Use Header.Instance instead");
		}

		this._user = ko.observable(null);
		this._dbName = ko.observable('');
		this.IsAuthenticated = ko.observable(false);
		this.LogoImage = ko.observable(null);
		this.BindEvents();
	}

	Render(target: string) {
		const container = document.getElementById(target);
		if (container) {
			ko.cleanNode(container);
			ko.applyBindings(this, container);
		}
	}

	GetTemplateName() {
		return 'MenuManager/Header/Templates/Header';
	}

	NavigateToHomePage() {
		this.Trigger('NAVIGATE_TO_HOME_PAGE');
	}

	ChangeLogoImage(profileImage: string) {
		this.LogoImage(profileImage || (this._user() && this._user().LicenseImage));
	}

	private BindEvents() {
		this.IsAuthenticated.subscribe(isAuthenticated => this.OnSessionChanged(isAuthenticated));
	}

	private OnSessionChanged(isAuthenticated: boolean) {
		if (isAuthenticated) {
			this.RefreshUser();
		} else {
			this._user(null);
		}
	}

	private RefreshUser() {
		this._user(UserManager.Instance.CurrentUser);
		this._user() && this._dbName(this._user().DbName);
	}

	get LogoUrl(){
		return `../../../../img/Custom/App/${Brand.Name}/official-main-logo-header.jpg`;
	}

	static get Instance(): Header {
		if (Header._instance == null) {
			Header._allowInstantiation = true;
			Header._instance = new Header();
			Header._allowInstantiation = false;
		}

		return Header._instance;
	}
}